import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DsPaginationComponent } from "./ds-pagination.component";
import { DsDropdownModule } from "../ds-dropdown/ds-dropdown.module";

@NgModule({
  declarations: [DsPaginationComponent],
  imports: [CommonModule, DsDropdownModule, FormsModule],
  exports: [DsPaginationComponent, DsDropdownModule],
})
export class DsPaginationModule {}
